// Angular
import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
// Local services
import { ClienteService } from '../../services/cliente.service';
import { RoleService } from '../../components/seguridad-creacion-rol/role.service';
// 3rd library
import swal from 'sweetalert2';
import {ProfileService} from '../../components/seguridad-creacion-perfil/profile.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  datosUser = [];
  loading = false;
  user: string;
  password: string;
  mensajeError = false;
  constructor(
    private clientService: ClienteService,
    private http: HttpClient,
    private roleService: RoleService,
    private route: ActivatedRoute,
    private router: Router,
    private profileService: ProfileService,
    private authService: AuthService,
  ) {
    this.authService.clearSession();
   }

  ngOnInit(): void {
    console.log("ET  06/02/2024 12:00");
    localStorage.setItem('currentUser', 'true');
  }

  login() {
    this.loading = true;
    this.clientService.loginUser(this.user, this.password).then(result => {
      this.profileService.getUserProfile({
        usuario: this.user.trim().toLowerCase(),
      }).then(profile => {
        if (profile && profile.codigo === 1) {
          if (profile.Respuesta.length > 0) {
            const userProfile = profile.Respuesta[0];
            if (userProfile.estado_rol && userProfile.estado_usuario) {
              if (userProfile.id_rol && userProfile.nombre_rol) {
                // Por la pantalla de login únicamente ingresan los Agentes INNEGOCSA,
                // los Agentes Bancarios se autentican con el token enviado por query param.
                if (!this.authService.canLoginWithCredentials(userProfile.nombre_rol)) {
                  this.loading = false;
                  this.clientService.logOut();
                  this.showNotification('Nota', 'El usuario no tiene permisos para acceder al portal');
                  return;
                }
                this.roleService.getPermissionsByRole(userProfile.id_rol).then(data => {
                  if (data && data.codigo === 1) {
                    const permissions = data.Respuesta;

                    if (permissions.length > 0) {
                      const ngxPermissions = this.authService.startSession(
                        userProfile.nombre_rol,
                        userProfile.id_rol,
                        permissions,
                        'INNEGOCSA'
                      );
                      if (ngxPermissions.length > 0) {
                        this.clientService.consultaCN(result[0].codigoEmpleado).then(infocn => {
                          localStorage.setItem('datacn', JSON.stringify({
                            codigocn: infocn.codigoCentroNegocio == null ? 0:infocn.codigoCentroNegocio,
                            nombrecn: infocn.descripcion==null?0:infocn.descripcion.split('-')[1]
                          }));
                          this.loading = false;
                          localStorage.setItem('updateVersionFlag','true');
                          this.router.navigate(['/gestionesab']);
                        }).catch(error => {
                          this.loading = false;
                          this.clientService.logOut();
                          this.showNotification('Nota', 'Ha ocurrido un error al obtener el Centro de Negocio del usuario')
                        })
                      } else {
                        this.loading = false;
                        this.clientService.logOut();
                        this.showNotification('Nota', 'El usuario no tiene permisos para acceder al portal');
                      }
                    } else {
                      this.loading = false;
                      this.clientService.logOut();
                      this.showNotification('Nota', 'El usuario no tiene permisos para acceder al portal');
                    }
                  } else {
                    this.loading = false;
                    this.clientService.logOut();
                    this.showNotification('Nota', 'El usuario no tiene permisos para acceder al portal');
                  }
                }).catch(error => {
                  console.log(error);
                  this.loading = false;
                  this.clientService.logOut();
                  this.showNotification('Un error ha ocurrido', 'El usuario no tiene permisos para acceder al portal.');
                });
              }
            } else {
              this.loading = false;
              this.clientService.logOut();
              this.showNotification('Nota', 'El rol de usuario se encuentra inactivo, comuníquese con soporte técnico.');
            }
          } else {
            this.loading = false;
            this.clientService.logOut();
            this.showNotification('Nota', 'El usuario no tiene permisos para acceder al portal');
          }
        } else {
          this.loading = false;
          this.clientService.logOut();
          this.showNotification('Nota', 'El usuario no tiene permisos para acceder al portal');
        }
      }).catch(error => {
        this.loading = false;
        this.showNotification('Un error ha ocurido', 'verifique sus credenciales');
      })
    }).catch(error => {
      this.loading = false;
      this.showNotification('Un error ha ocurido', 'verifique sus credenciales');
    });
  }
  showNotification(title, message) {
    swal.fire({
      title: title,
      text: message,
      confirmButtonColor: '#fff',
      background: '#eeedf2',
      customClass: {
        confirmButton: 'btn button-precas',
        input: 'inputswt',
        title: 'titleswt'
      },
      showCloseButton: true,
      buttonsStyling: false,
      heightAuto: false,
      confirmButtonText: 'Continuar'
    }).then(result => {

    });
  }
}
